import constate from 'constate';
import { BlockDimensions } from '../../types';
import { useState, useMemo, useEffect } from 'react';

export const useBlockDimensions = constate((dimensions: BlockDimensions) => {
  const [blockDimensions, setDimensions] = useState(dimensions);
  useEffect(() => setDimensions(dimensions), [dimensions]);
  return useMemo(() => blockDimensions, [blockDimensions]);
});
